import { URLS } from '../../config/application';

export const MENU_LINKS = [
  { icon: 'home', stroke: 'neutral-600', name: 'Home', to: URLS.home },
  { icon: 'send', stroke: 'neutral-600', name: 'Leads', to: URLS.jobs },
  { icon: 'job', stroke: 'neutral-600', name: 'Jobs', to: URLS.jobs },
  {
    icon: 'settings',
    name: 'Account settings',
    to: URLS.accountSettings,
    stroke: 'neutral-600',
  },
];

export const MENU_ADMIN_LINKS = [
  {
    name: 'Company information',
    to: URLS.companyInformation,
    icon: 'toolbox',
    stroke: 'neutral-600',
  },
  {
    name: 'Job settings',
    to: URLS.jobSettings,
    icon: 'job',
    stroke: 'neutral-600',
  },
  {
    name: 'Team members',
    to: URLS.teamSettings,
    icon: 'user',
    stroke: 'neutral-600',
  },
  {
    name: 'Notification Preferences',
    to: URLS.notificationPreferences,
    icon: 'notification',
    stroke: 'neutral-600',
  },
];

export const LOGOUT_LINK = {
  icon: 'logout',
  name: 'Log Out',
  to: URLS.logout,
  stroke: 'neutral-600',
};

export const MENU_VERIFICATION_LINKS = {
  icon: 'verification',
  name: 'Director verification',
  to: URLS.directorVerification,
  stroke: 'neutral-600',
};

export const STAFF_IMITATE_USER_MENU_LINK = {
  name: 'Imitate user',
  icon: 'user',
  to: URLS.staffLogin,
};

export const SKELETONS = {
  banner: {
    height: 60,
  },
  companyName: {
    width: 160,
  },
  plan: {
    width: 120,
  },
};
